import { c as _c } from "react/compiler-runtime";
type DividerProps = {
  fullScreen?: boolean;
  className?: string;
};
export function Divider(t0) {
  const $ = _c(2);
  const {
    fullScreen,
    className
  } = t0;
  const t1 = `h-px bg-gray-200 ${fullScreen ? "-mx-4 md:-mx-6" : ""} ${className ?? ""}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}